import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import styled, { css } from 'styled-components';

import { Spinner, FadeIn, Message } from '../easyclaim.app.components/index';

import { ScreenComponent } from './ScreenComponent';

export class Upload extends ScreenComponent<AppState, {}> {
	public render() {
		const spinner = (
			<Spinner
				dotStyle={{
					margin: '0.66rem',
					size: '1rem',
				}}
			/>
		);

		return (
			<div className="main-container">
				<Container>
					{spinner}
					<Message>
						<FormattedMessage id="upload.message" />
					</Message>
				</Container>
			</div>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	animation: ${css`
			${FadeIn}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) forwards;
`;
